import React from "react";
import { Helmet } from "react-helmet";
import Container from "@material-ui/core/Container";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { endOfTitle } from "../../../constants/constants";
import FilterResults from "../components/managedStudent/FilterResults";
import Filter from "../components/managedStudent/Filter";
import { ManagedStudentsPageProvider } from "../context/managedStudentsPageContext";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "center",
    columnGap: 24,
  },
  filterContainer: {
    position: "relative",
  },
  filterResultContainer: {
    width: 732,
  },
}));

export const ManagedStudentsPage = ({ userRole }) => {
  const classes = useStyles();

  return (
    <>
      <Helmet>
        <title>Students{endOfTitle}</title>
      </Helmet>
      <ManagedStudentsPageProvider userRole={userRole}>
        <Container maxWidth="lg" className={classes.root}>
          <div className={classes.filterContainer}>
            <Filter />
          </div>
          <div className={classes.filterResultContainer}>
            <FilterResults />
          </div>
        </Container>
      </ManagedStudentsPageProvider>
    </>
  );
};
